<template>
  <div class="flex flex-center q-pa-xl">
    <q-card class="text-center q-pa-lg" flat bordered>
      <q-card-section class="q-gutter-md">
        <q-icon name="lock" size="4rem" color="accent" class="q-mb-md" />
        <div class="text-h4 q-mb-md text-weight-medium">Access Restricted</div>
        <p class="text-body1 text-grey-7 q-mb-lg" style="max-width: 400px; margin: 0 auto">
          You don't have permission to view this page. Please contact your organization
          administrator to request access or adjust your group permissions.
        </p>
        <div class="q-gutter-sm">
          <q-btn no-caps outline color="primary" size="md" @click="goBack" class="q-px-lg">
            <q-icon left name="arrow_back" />
            Go Back
          </q-btn>
          <q-btn no-caps unelevated color="primary" size="md" @click="goHome" class="q-px-lg">
            <q-icon left name="space_dashboard" />
            Go to Dashboard
          </q-btn>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script lang="ts">
export default {
  name: 'AccessRestrictedView',
  methods: {
    goHome() {
      this.$router.push({ name: 'Dashboard' })
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'Dashboard' })
      }
    }
  }
}
</script>
